import { Part } from "./part.model";

export class Spare extends Part { }